
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#7D7D7D"}},[_c('path',{attrs:{"d":"M8.926 18h-3.95c-2.06 0-3.733-1.695-3.733-3.78V3.556h11.416v10.658c0 2.085-1.674 3.78-3.733 3.78V18zm-6.832-3.78c0 1.608 1.294 2.918 2.882 2.918h3.95c1.588 0 2.882-1.31 2.882-2.918V4.418H2.094v9.802z"}}),_c('path',{attrs:{"d":"M12.54 4.43c-.045 0-.096 0-.142-.006H1.47A1.469 1.469 0 010 2.942c0-.816.658-1.483 1.464-1.483h11.207c.811.087 1.401.81 1.322 1.626-.04.397-.227.753-.528 1.006a1.43 1.43 0 01-.93.339h.005zM1.464 2.32a.614.614 0 00-.613.62.62.62 0 00.619.627h10.974a.66.66 0 00.493-.138.65.65 0 00.222-.42.623.623 0 00-.556-.683H1.47l-.006-.006z"}}),_c('path',{attrs:{"d":"M9.516 2.315H4.38l-.108-.27A1.486 1.486 0 015.629 0h2.627c.812 0 1.47.666 1.47 1.488 0 .19-.034.38-.102.557l-.108.27zm-4.494-.861h3.853a.624.624 0 00-.613-.592H5.635a.624.624 0 00-.613.592zM4.386 15.116a.431.431 0 01-.425-.431V6.199c0-.235.193-.43.425-.43.233 0 .426.195.426.43v8.486c0 .236-.193.43-.426.43zM6.951 15.116a.431.431 0 01-.426-.431V6.199c0-.235.193-.43.426-.43.233 0 .426.195.426.43v8.486c0 .236-.193.43-.426.43zM9.516 15.116a.431.431 0 01-.426-.431V6.199c0-.235.193-.43.426-.43.232 0 .425.195.425.43v8.486c0 .236-.193.43-.425.43z"}})])])
          )
        }
      }
    